// src/JoinPage.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAuthSession } from "@aws-amplify/auth";

const API_BASE_URL = "https://api.cupvisor.org";

export default function JoinPage({ user, signOut }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [jwtToken, setJwtToken] = useState("");
  const joinToken = new URLSearchParams(location.search).get("joinToken");

  // grab the Cognito JWT
  useEffect(() => {
    async function loadSession() {
      try {
        const session = await fetchAuthSession();
        setJwtToken(session.tokens.idToken.toString());
      } catch (err) {
        console.error("Error loading session:", err);
      }
    }
    loadSession();
  }, [user]);

  // when we have both the JWT and joinToken, hit the API
  useEffect(() => {
    async function joinCard() {
      if (!jwtToken || !joinToken) return;
      try {
        const res = await fetch(
          `${API_BASE_URL}/customer/join-card?joinToken=${encodeURIComponent(
            joinToken
          )}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Accept": "application/vnd.apple.pkpass" 
            },
          }
        );
        if (!res.ok) throw new Error(`Server returned ${res.status}`);

        // **this is the important part**: pull down the .pkpass as a blob
        const blob = await res.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "loyalty.pkpass";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);

        // then redirect with a success message
        setTimeout(
          () =>
            navigate("/users", {
              state: { message: "Card added to Wallet – check your downloads!" },
            }),
          1000
        );
      } catch (err) {
        console.error("Error joining card:", err);
        setTimeout(
          () =>
            navigate("/users", {
              state: { message: "Error joining card: " + err.message },
            }),
          2000
        );
      }
    }
    joinCard();
  }, [jwtToken, joinToken, navigate]);

  return (
    <div className="container mt-5">
      <h2>Adding your card…</h2>
      <p>Please wait while we prepare your Wallet file.</p>
    </div>
  );
}
